<template>
 <div>
  <el-card>
    <el-form :inline="true" :model="Formfeedback" class="demo-form-inline">
  <el-form-item >
    <el-input v-model="Formfeedback.content" placeholder="问题关键字"></el-input>
  </el-form-item>
  <el-form-item>
    <el-select v-model="Formfeedback.title" clearable  placeholder="选择问题类型">
      <el-option label="功能异常" value="功能异常：功能故障或不可用"></el-option>
      <el-option label="产品建议" value="产品建议：用的不爽或我有更好的想法"></el-option>
      <el-option label="支付问题" value="支付问题：无法支付或支付慢"></el-option>
      <el-option label="其他问题" value="其他问题"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item >
    <el-input v-model="Formfeedback.userName" placeholder="问题人姓名/手机号"></el-input>
  </el-form-item>
  <el-form-item>
   <el-date-picker
      v-model="Formfeedback.feedbackStartTime"
      type="datetime"
      format="yyyy-MM-dd"
      value-format="yyyy-MM-dd"
      placeholder="开始日期">
    </el-date-picker>
    至
    <el-date-picker
      v-model="Formfeedback.feedbackEndTime"
      format="yyyy-MM-dd"
      value-format="yyyy-MM-dd"
      type="datetime"
      placeholder="截止日期">
    </el-date-picker>
</el-form-item>
<el-form-item>
    <el-button type="primary" icon="el-icon-search" @click="onSubmit" v-auth="'/Feedback/search'">查询</el-button>
    <el-button type="primary" icon="el-icon-refresh" @click="whole" v-auth="'/Feedback/refresh'">重置</el-button>
  </el-form-item>
  </el-form>
  </el-card>
   <el-card style="margin-top:20px;">
     <div class="Tabs">
     <b @click="whole('全部')" ref="whole">全部</b>
     <b @click="Waiting('待回复')" ref="Waiting">待回复({{recosnum == '' ? recosnums : recosnum}})</b>
     <b @click="replied('已回复')" ref="replied">已回复</b>
     <el-button @click="dialogVisible = true" style="height:40px; width:94px; display: inline-block;" v-auth="'/Feedback/batchRestore'">批量回复</el-button>
     <!-- <el-button style="margin-left:10px;background-color:#fff;" @click="">问题类型</el-button> -->
   <div v-auth="'/Feedback/revise'" class="Elbutton">
      <el-dropdown  trigger="click" @command='handleCommand'>
      <span class="el-dropdown-link" style="height:40px; width:94px; display: inline-block;">
        问题类型<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item :command='item.type' v-for="(item,idx) in typeString" :key="idx">{{item.title}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
   </div>
   </div>
    <el-table
    ref="multipleTable"
    :data="feedbackList"
    tooltip-effect="dark"
    style="width: 100%"
    v-loading="showloading"
    element-loading-text="拼命加载中"
    @selection-change="handleSelectionChange"
    >
    <el-table-column
      type="selection"
      width="55">
    </el-table-column>
    <el-table-column
      prop="content"
      label="问题描述"
      width="260"
      >
      <template slot-scope="scope">
           <el-button @click="changePid(scope.row)" type="text">{{scope.row.content}}</el-button>
       </template>
    </el-table-column>
    <el-table-column
      prop="title"
      label="类型"
      width="120"
      :formatter="formatterType"
      >
    </el-table-column>
    <el-table-column
      prop="answer"
      label="回复"
      show-overflow-tooltip>
    </el-table-column>
    <el-table-column
      prop="answerUserName"
      label="处理人"
      show-overflow-tooltip>
    </el-table-column>
    <el-table-column
      prop="sourceType"
      label="来源"
      show-overflow-tooltip>
    </el-table-column>
    <el-table-column
     v-if="this.Formfeedback.isSolved == '0'"
      prop="answerTime"
      label="回复时间"
      show-overflow-tooltip>
    </el-table-column>
    <el-table-column
     v-else
      prop="createTime"
      label="提交时间"
      show-overflow-tooltip>
    </el-table-column>
  </el-table>
  <el-pagination
  @size-change="handleSizeChange"
  @current-change="handleCurrentChange"
  :current-page="Formfeedback.pageNumber"
  :page-sizes="[10, 20, 30, 40]"
  :page-size="Formfeedback.pageSize"
  layout="total, sizes, prev, pager, next, jumper"
  :total="total">
</el-pagination>
   </el-card>
  <el-dialog
  title="批量回复"
  :visible.sync="dialogVisible"
  width="30%"
  :before-close="handleClose"
  >
   <el-form label-position="top" :model="FeedbackObj">
     <el-form-item>
     <el-input type="textarea" v-model="FeedbackObj.answer"></el-input>
     </el-form-item>
   </el-form>
  <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="Submit">确 定</el-button>
    </span>
 </el-dialog>
 </div>
</template>
<script>
export default{
  name:'feedBack',
    data () {
        return {
            formInline: {
          user: '',
          region: ''
        },
         ArrList:[],
          total:0,
          FeedbackObj:{
          answer:'',
          },
        Formfeedback:{
          pageSize:10,
          pageNumber:1,
          content:'',
          title:'',
          userName:'',
          feedbackStartTime:'',
          feedbackEndTime:'',
          isSolved:''
        },
        feedbackList:[],
        showloading:false,
        recosnum:'',
        recosnums:'',
        dialogVisible:false,
        typeString:[
          {
          type:'功能异常：功能故障或不可用',
          title:'功能异常'
          },
          {
            type:'产品建议：用的不爽或我有更好的想法',
            title:'产品建议'
          },
          {
            type:'支付问题：无法支付或支付慢',
            title:'支付问题'
          },
          {
            type:'其他问题',
            title:'其他问题'
          }
        ],
        }
    },
    created () {
      // this.getfeedbackList()
     this.$nextTick(()=>{
      const code = sessionStorage.getItem('code')
        if(code == '待回复'){
      this.Waiting()
        }else if(code == '已回复'){
          this.replied()
        }else if(code == '全部'){
      this.whole()
        }else{
        this.Waiting()
        }
    })
    },
    mounted(){
      this.recosnums = sessionStorage.getItem('nums')
    },
    computed:{
      
    },
    methods:{
      // 批量回复
      Submit(){
     this.api.feedback.feedbackAnswer({idList:this.ArrList,...this.FeedbackObj}).then(res =>{
       this.$message.success(res.message)
      //  consloe.log(res)
      this.dialogVisible = false
      this.FeedbackObj = {answer:''}
      this.ArrList = []
       this.getfeedbackList()
     })
      },
      //格式化类型
    formatterType(row,column,cellValue,index){
       return cellValue.split('：')[0]
      },
      // 下拉选择器
      handleCommand(command){
     console.log(command);
     this.api.feedback.updateFeedBack({idList:this.ArrList,title:command}).then(res =>{
       this.ArrList= []
       this.getfeedbackList()
     })
      },
      // 初始列表
      getfeedbackList(){
        this.showloading = true
    if(this.api.feedback.getfeedback){
        this.api.feedback.getfeedback(this.Formfeedback).then((res)=>{
      // console.log(res);
      this.total = res.data.total
      console.log(new Date(res.data.records.answerTime).getTime() - new Date(res.data.records.answerTime).getTime());
      this.feedbackList =  res.data.records
      this.showloading = false
      if(this.Formfeedback.isSolved == 1){
      this.recosnum = res.data.total
      sessionStorage.setItem('nums',this.recosnum)
      }
      })
    }
      },
      //搜索
      onSubmit(){
        this.getfeedbackList()
      },
      // pageSize
    handleSizeChange(val) {
      this.Formfeedback.pageSize = val
      this.getfeedbackList()
    },
    // pageNumber
    handleCurrentChange(val) {
      this.Formfeedback.pageNumber = val
      this.getfeedbackList()
    },
    //待回复
    Waiting(str){
      sessionStorage.setItem('code',str)
      this.Formfeedback={
          pageSize:10,
          pageNumber:1,
          isSolved:'1'
        }
      this.$refs.Waiting.style.color = 'black'
      this.$refs.replied.style.color = '#9e99a7'
      this.$refs.whole.style.color = '#9e99a7'
        this.getfeedbackList()
    },
    //已回复
    replied(str){
      sessionStorage.setItem('code',str)
      this.Formfeedback={
          pageSize:10,
          pageNumber:1,
          isSolved:'0'
        }
      this.$refs.Waiting.style.color ='#9e99a7'
      this.$refs.whole.style.color = '#9e99a7'
      this.$refs.replied.style.color = 'black'
         this.getfeedbackList()
        
    },
    //全部
    whole(str){
      sessionStorage.setItem('code',str)
       this.Formfeedback={
          pageSize:10,
          pageNumber:1,
          content:'',
          type:'',
          userName:'',
          feedbackStartTime:'',
          feedbackEndTime:'',
          isSolved:''
        }
      this.$refs.Waiting.style.color ='#9e99a7'
      this.$refs.replied.style.color = '#9e99a7'
      this.$refs.whole.style.color = 'black'
        this.getfeedbackList()
    },
    changePid(row){
    this.$router.push({
      path:'/Feedbackdetailed',
      query:{id:row.id}
    })
    },
    handleSelectionChange(val){
    this.ArrList = val.map( i =>{
     return i.id
      })
     
    },
    handleClose(){
          this.dialogVisible = false
          this.FeedbackObj = {answer:''}
    }
    }
}
</script>
<style lang='less'  scoped>
    .Tabs {
      position: relative;
      b{
      color: #9e99a7;
      font-size: 15px;
      padding: 0 20px;
      cursor: pointer;
      }
    }
    .Elbutton{
      display: inline-block;
      height:40px; 
      width:94px; 
      margin-left: 30px;
      border:1px solid #DCDFE6; 
      text-align:center; 
      line-height:40px; 
      border-radius:4px;
      margin-left:30px;
      cursor: pointer;
    }
     /deep/.el-textarea__inner{
      resize: none;
      height: 140px;
    }
    /deep/.el-form-item__label{
      font-size: 17px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Feedback/index.vue